// O GET de opções do 2FA leva o CPF na query string, e o Sentry grava a URL inteira no breadcrumb.
export function ocultaCpf(breadcrumb) {
    if (!breadcrumb.data?.url) {
        return breadcrumb;
    }
    const url = breadcrumb.data.url.replace(/([?&]cpf=)[^&#]*/g, '$1[filtrado]');
    return { ...breadcrumb, data: { ...breadcrumb.data, url } };
}
